import React, {FC, useContext} from 'react';
import {Redirect, Route, RouteProps} from 'react-router';
import {AuthContext} from "../providers/AuthProvider";
import {useLocation} from "react-router-dom";

const PrivateRoute: FC<RouteProps> = ({component: Component, ...rest}) => {
    const {user} = useContext(AuthContext);
    const {pathname, search} = useLocation();

    return <Route {...rest} render={(props) => {

        if (user) {
            const aYearAgo = new Date();
            aYearAgo.setFullYear(aYearAgo.getFullYear() - 1);
            const hasExpiredPassword = user && (!user.dateLimiteValiditeMotDePasse || new Date(user.dateLimiteValiditeMotDePasse) <= aYearAgo);
        
            if (hasExpiredPassword && pathname !== '/expired_password') {
                return <Redirect to={`/expired_password?r=${encodeURIComponent(pathname + search)}`}/>
            }

            return <Component {...props}/>;
        } else {
            const redirect = `?r=${encodeURIComponent(pathname + search)}`

            return <Redirect to={`/login${['/', '/login'].includes(pathname) ? '' : redirect}`}/>
        }
    }}/>
};

export default PrivateRoute;
